var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('div',{staticClass:"d-flex"},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.close}},[_c('v-icon',{attrs:{"size":"18"}},[_vm._v("mdi-close-box")])],1),_c('span',{staticClass:"pa-2"},[_vm._v(_vm._s(_vm.item.text))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }